import React, {useState} from 'react'
import {ErrorState} from '../../Primitives'
import {useAlert} from 'react-alert'
import {playground} from '~/pages/Playground'
import {useHistory} from 'react-router-dom'
import {getGraphQLErrorMessage} from '~/util'
import {ApolloError} from '@apollo/client'
import {CheckYourEmail2} from '~/components/Primitives/CheckYourEmail2'

export type PageState = {
    errorState: ErrorState
    email?: string
    organisationIdStr?: string
    directoryName?: string
    code?: string
}

export const StripeFlow = ({
    pageState,
    setPageState,
    requestOtp,
    signInOtp,
    onComplete,
}: {
    pageState: PageState
    setPageState: (value: PageState) => void
    requestOtp: (emailAddress: string) => Promise<void>
    signInOtp: (otp: string, email: string) => Promise<boolean>
    onComplete: (directoryName: string) => Promise<string | undefined>
}) => {
    const [loading, setLoading] = useState<boolean>(false)
    const alert = useAlert()
    const history = useHistory()

    return (
        <CheckYourEmail2
            loading={loading}
            setLoading={setLoading}
            code={pageState.code || ''}
            setCode={(value) => setPageState({...pageState, code: value})}
            onNext={async () => {
                if (!pageState.code || !pageState.email) return
                setPageState({...pageState, errorState: {code: {visible: false, message: ''}}})
                try {
                    const result = await signInOtp(pageState.code, pageState.email)
                    if (!result) {
                        setPageState({...pageState, errorState: {code: {visible: true, message: 'Invalid code'}}})
                    } else {
                        const organisationIdStr = await onComplete(pageState.directoryName || 'Untitled')
                        setPageState({...pageState, organisationIdStr})
                        organisationIdStr && history.push(`/${organisationIdStr}/admin?welcome=1`)
                    }
                } catch (err) {
                    alert.error(getGraphQLErrorMessage(err as ApolloError))
                }
            }}
            onDidntGetCode={async () => {
                if (!pageState.email) return
                await requestOtp(pageState.email)
                alert.success('We have emailed you a new code.')
            }}
            errorState={pageState.errorState}
            setErrorState={(value) => setPageState({...pageState, errorState: value})}
        />
    )
}

playground.push({
    path: 'src/components/Onboarding/SelfBuild/StripeFlow.tsx',
    component: StripeFlow,
    props: {
        pageState: {
            formState: {},
            errorState: {},
        },
    },
    propOptions: {
        page: {
            get: (props: any) => JSON.stringify(props.page),
        },
        setPage: ({props, args}: {props: any; args: any[]}) => {
            return {...props, page: args[0]}
        },
        pageState: {
            get: (props: any) => JSON.stringify(props.pageState),
        },
        setPageState: ({props, args}: {props: any; args: any[]}) => ({...props, pageState: args[0]}),
        requestOtp: () => {},
        signInOtp: () => {},
        onComplete: () => {},
    },
})
